import { Lang } from '../../../translations/lang'
import { ShippingStateValue } from '../../../types/typescript-axios'

export const ShippingStateSelects = [
  [Lang.all, ''] as const,
  [
    Lang.shippingStateName.SHIPPED,
    ShippingStateValue.Shipped as string,
  ] as const,
  [
    Lang.shippingStateName.RETURNED,
    ShippingStateValue.Returned as string,
  ] as const,
  [
    Lang.shippingStateName.DISPOSED,
    ShippingStateValue.Disposed as string,
  ] as const,
  [
    Lang.shippingStateName.REUSABLE_STOCKED,
    ShippingStateValue.ReusableStocked as string,
  ] as const,
  [
    Lang.shippingStateName.REUSABLE_SHIPPED,
    ShippingStateValue.ReusableShipped as string,
  ] as const,
  [
    Lang.shippingStateName.REUSABLE_LEND,
    ShippingStateValue.ReusableLend as string,
  ] as const,
  [
    Lang.shippingStateName.REUSABLE_COLLECTED,
    ShippingStateValue.ReusableCollected as string,
  ] as const,
  [
    Lang.shippingStateName.DEFECTIVE,
    ShippingStateValue.Defective as string,
  ] as const,
  [Lang.shippingStateName.LOST, ShippingStateValue.Lost as string] as const,
]
